import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserAccessService {
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getItem(key: string): string {
    const item = localStorage.getItem(key);
    return item ? item : '';
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
